import React, { useEffect, useState } from 'react';
import { formatDateParsedZoneLong } from 'platform/utilities/date/index';
import PropTypes from 'prop-types';
import { requestsContainStatus } from '../utilities/poaRequests';

const ClaimantSearchHasPOA = ({ searchData, claimant }) => {
  const [resultsSummary, setResultsSummary] = useState('');

  const lastFour = ssn => {
    return ssn?.substring(5);
  };

  useEffect(() => {
    setTimeout(
      () =>
        setResultsSummary(
          <>
            Showing result for <strong>"{searchData.first_name}"</strong>
            {', '}
            <strong>"{searchData.last_name}"</strong>
            {', '}
            <strong>"{formatDateParsedZoneLong(searchData.dob)}"</strong>
            {', '}
            <strong>
              "***-**-
              {lastFour(searchData.ssn)}"
            </strong>
          </>,
        ),
      150,
    );
  }, []);

  const claimantOverviewLabel =
    claimant?.firstName && claimant?.lastName
      ? `Go to the claimant overview for ${claimant.lastName}, ${claimant.firstName}`
      : 'Go to the claimant overview';
  const checkStatus = status => {
    if (
      status.representative &&
      requestsContainStatus('pending', status.poaRequests)
    ) {
      return true;
    }
    return null;
  };
  const statusAlert = claim => {
    const actionablePendingPOA = claim.poaRequests?.find(
      poaRequest =>
        poaRequest.resolution === null && poaRequest.canAccept !== false,
    );

    if (actionablePendingPOA) {
      return (
        <va-alert status="warning" visible>
          <h2>There is a pending representation request</h2>
          <p className="vads-u-margin-y--0">
            To establish representation with this claimant, review and accept
            the pending representation request.
          </p>
          <va-link-action
            href={`/representative/representation-requests/${actionablePendingPOA.id}`}
            text="Review the representation request"
            type="primary"
          />
        </va-alert>
      );
    }

    return null;
  };
  return (
    <>
      <hr className="divider claimant-search" aria-hidden="true" />
      <p
        data-testid="representation-requests-table-fetcher-poa-requests"
        className="claimant__results-text"
        role="status"
      >
        {resultsSummary}
      </p>
      {statusAlert(claimant)}
      <h2 className="claimant__name">
        {claimant.lastName}, {claimant.firstName}
      </h2>
      <p className="poa-request__card-field vads-u-margin-bottom--2">
        <span>{claimant.city}</span>
        <span>
          {claimant.city ? ', ' : ''}
          {claimant.state}
        </span>
        <span> {claimant.postalCode}</span>
      </p>
      {claimant.representative ? (
        <p className="vads-u-margin-bottom--2 vads-u-margin-top--2">
          <strong>Representative:</strong> {claimant.representative}
        </p>
      ) : (
        <p>
          <strong>Note: </strong>
          You don’t currently represent this claimant
        </p>
      )}
      {claimant.representative &&
        (checkStatus(claimant) ? (
          <va-link
            href={`/representative/find-claimant/claimant-overview/${claimant.id}`}
            text="Go to the claimant overview"
            label={claimantOverviewLabel}
            type="primary"
          />
        ) : (
          <va-link-action
            href={`/representative/find-claimant/claimant-overview/${claimant.id}`}
            text="Go to the claimant overview"
            label={claimantOverviewLabel}
            type="primary"
          />
        ))}
    </>
  );
};

export default ClaimantSearchHasPOA;

ClaimantSearchHasPOA.propTypes = {
  claimant: PropTypes.object,
  searchData: PropTypes.object,
};
